import type { StoryblokRichTextNode } from "@storyblok/react";
import type { ReactElement } from "react";
import TabModule from "../../components/TabModule";
import GridItem from "../../components/general/GridItem";
import { getUrlFromStoryblokLink } from "../../utils/storyblok/urls";
import { notUndefined } from "../../utils/type-guards/general";

const TabsModule = ({ headline, image, tabs }: Queries.TabsModuleFragment) => {
	const tabsProps = tabs
		?.map((tab) => {
			if (!tab || !tab.label) {
				return;
			}

			const firstButton = tab.button?.[0];
			const buttonProps =
				firstButton && firstButton.link && typeof firstButton.label === "string"
					? {
							link: getUrlFromStoryblokLink(firstButton.link),
							label: firstButton.label,
						}
					: undefined;

			return {
				header: tab.title ?? "",
				richtext: tab.text as StoryblokRichTextNode<ReactElement>,
				label: tab.label,
				cta: buttonProps ?? undefined,
				image: tab.image ?? undefined,
			};
		})
		.filter(notUndefined);

	return headline && image?.filename && tabsProps ? (
		<GridItem fullWidth>
			<TabModule
				headline={headline}
				image={{ src: image.filename, alt: image.alt ?? undefined }}
				tabs={tabsProps}
			/>
		</GridItem>
	) : null;
};

export default TabsModule;
